module.exports = __webpack_public_path__ + "img/c2.4d171a7b.png";